<template lang='pug'>
	div#app
		router-view
</template>

<script>
export default {
	name: 'App',
	created: function() {
		this.$store.dispatch('getCities')
	}
}
</script>
